import { useServiceAreaById } from '@/hooks/useServiceAreaById'
import { SERVICE_AREA_ID, SERVICE_AREA_NAME } from '@/lib/constants'

export function useGeneralEnquiryServiceArea() {
  const generalEnquiryServiceArea = useServiceAreaById(
    SERVICE_AREA_ID.generalEnquiry,
  )

  if (!generalEnquiryServiceArea) {
    throw new Error(
      `Failed to find the ${SERVICE_AREA_NAME.generalEnquiry} service area`,
    )
  }

  return generalEnquiryServiceArea
}
